import React, { Component } from 'react'
import UploadEncrypt from './components/UploadEncrypt'
import UploadDecrypt from './components/UploadDecrypt'
import Content from './components/content'
import './assets/css/style.css'
import Header from './components/Header'
import Footer from './components/Footer'
import ContentService from './services/ContentService'
export class App extends Component {
  constructor(props) {
    super(props)
    this.state = { contents: [] , count : 0 , github : null , sitename : null   }
  }

  async componentDidMount() {
    await this.fetch();
  }

  async fetch() {
    const data = await ContentService.getContent()
    const contents = data.data.value;
    const count = data.data.count;
    const github = data.data.names.github_links;
    const sitename = data.data.names.website_name;
    this.setState({ contents, count , github  , sitename  })
  }
  render() {
    return (
      <>
        <Header github={this.state.github} sitename={this.state.sitename} />
        <main className="__container">
          <section className="grid grid-cols-12 mt-10 lg:mt-20  md:gap-x-10 lg:gap-x-20 gap-y-10">
            <UploadEncrypt classes="md:col-span-6 col-span-12" />
            <UploadDecrypt classes="md:col-span-6 col-span-12" />
          </section>

          <section className="grid grid-cols-12 mb-10 mt-10 lg:mt-20 gap-y-5 md:gap-x-10 lg:gap-x-5 md:min-h-[450px] min-h-[400px]">
            {this.state.contents.length !== 0 && <Content contents={this.state.contents} />}
            
          </section>
        </main>
        <Footer count={this.state.count}  sitename={this.state.sitename}/>
      </>
    )
  }
}

export default App